const crypto = require('crypto');

export const getSafe = (cb) => {
  try {
    return cb();
  } catch (error) {
    // console.error(error);
  }
  return null;
};

export const secureEmail = (email) => {
  if (!email) return "";
  const [username, domain] = email.split("@");
  const secure = username
    .split("")
    .map((char, i, arr) => {
      if (i < 2 || i > arr.length - 2) return char;
      return "*";
    })
    .join("");
  return `${secure}@${domain}`;
};

export const securePhone = (phone) => {
  const str = phone.toString()
  const secure = str
    .split("")
    .map((char, i, arr) => {
      if (i < 1 || i > arr.length - 3) return char;
      return "*";
    })
    .join("");
  return `${secure}`;
};

export const getServerError = (error) => {
  const message = getSafe(() => error.response.data.error.message[0].message);
  let auxMessage = '';
  if (typeof message === 'object') {
    auxMessage = message[0].message;
  } else {
    auxMessage = message;
  }
  return auxMessage || 'Inténtalo de nuevo en unos minutos.';
};

export const encryptData = (payload) => {
  const { VUE_APP_RSA_PUBLIC_LAMBDA_PROFILE } = process.env;
  const rsaPublicKey = {
    key: VUE_APP_RSA_PUBLIC_LAMBDA_PROFILE,
    passphrase: "",
    padding: crypto.constants.RSA_PKCS1_PADDING,
  };
  const buffer = Buffer.from(JSON.stringify(payload), "utf8");
  const encrypted = crypto.publicEncrypt(rsaPublicKey, buffer);
  const dataEncrypt = encrypted.toString("base64");
  return dataEncrypt;
};

export const onlyText = (event, value) => {
  // eslint-disable-next-line
  const regular = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+$/;
  const regex = new RegExp(regular);
  const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key) || (value[0] === undefined && /^\s/.test(key))) {
    event.preventDefault();
    return;
  }
  // eslint-disable-next-line consistent-return
  return true;
};

// eslint-disable-next-line consistent-return
export const onlyNumber = (event) => {
  event = event || window.event;
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
    event.preventDefault();
  } else {
    return true;
  }
};

export const alphaNumeric = (event) => {
  event = event || window.event;
  const char = String.fromCharCode(event.which || event.keyCode);
  if (!/^[a-zA-Z0-9]+$/.test(char)) {
    event.preventDefault();
  }
};

export const verifyPhone = (event, value) => {
  const regular = /^\+\d{0,15}$/;
  const regex = new RegExp(regular);
  const { key } = event;
  const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
  if (controlKeys.includes(key)) {
    return true;
  }
  if (value.length === 0 && key !== '+') {
    event.preventDefault();
    return false;
  }
  if (event.target.selectionStart === 0 && key !== '+') {
    event.preventDefault();
    return false;
  }
  if (key === '+' && value.includes('+')) {
    event.preventDefault();
    return false;
  }
  if (!/^\d$/.test(key) && key !== '+') {
    event.preventDefault();
    return false;
  }
  const newValue = value + key;
  if (!regex.test(newValue)) {
    event.preventDefault();
    return false;
  }
  return true;
};
export function validateRequiredFields(obj) {
  const emptyFields = Object.entries(obj).reduce((acc, [key, val]) => {
    if ((val === '' || val === null || val === undefined)) {
      acc.push(key);
    }
    return acc;
  }, []);
  return emptyFields;
}